import BaseService from '@/services/BaseService'
import { http } from './config'

class LancamentoBancarioService extends BaseService {
    constructor(){
        super('/v1/lancamentos-bancarios')
    }

    listar(data){
        // const queryParams =`id=${data.id ? data.id : ''}
        // &contato=${data.contato ? data.contato : ''}
        // &dataLancamento=${data.dataLancamento ? data.dataLancamento : ''}
        // &tipo=${data.tipo ? data.tipo : ''}
        // &bancoId=${data.bancoId ? data.bancoId : ''}
        // &limit=${data.limit ? data.limit : 20}
        // &page=${data.page ? data.page : 1}
        // `

        return http.get(`/v1/lancamentos-bancarios`, {params: data})
    }

    atualizar(data) {
        const id = data.get('id')
        return http.post(`/v1/lancamentos-bancarios/${id}`, data)
    }

    listarPorDataDeLancamento(data) {
        return http.get(`/v1/lancamentos-bancarios?periodo_inicial=${data.periodo_inicial}&periodo_final=${data.periodo_final}&content=${data.content}`)
    }

    imprimir(id) {
        return http.get(`/v1/lancamento-bancario/${id}/comprovante/cupom`)
    }
}

export default new LancamentoBancarioService